import React from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from "../../Common/containers/MetaDataWrapper";
import {get} from "lodash";
import {getFBImage} from "../../Common/components/Image";
import config from "../../../config";
import withErrorBoundary from "../../Errors/components/withErrorBoundry";

const ArticleHelmetProps = ({ embedded, article, canonical, topImageSet }) => {
  const helmetProps = {
    meta: []
  };

  function _meta(name, content) {
    helmetProps.meta.push({name, content});
  }

  function _ogMeta(property, content) {
    helmetProps.meta.push({property, content});
  }

  if (!embedded) {
    _meta("twitter:site", "@SportingLife");
    _meta("twitter:card", "summary_large_image");
    _ogMeta("og:type", "article");
    _ogMeta("og:locale", "en_GB");

    if (article.long_headline) {
      helmetProps.title = article.long_headline;
      _ogMeta("og:title", article.long_headline);
    }

    if (article.article_abstract) {
      _ogMeta("og:description", article.article_abstract);
    }

    if (get(canonical, 'link[0].href', undefined)) {
      Object.assign(helmetProps, canonical);
      _ogMeta("og:url", canonical.link[0].href);
    }

    if (topImageSet.artefacts && topImageSet.artefacts.length > 0) {
      const shareImage = getFBImage(topImageSet.artefacts);
      const shareImageUri = `${config.canonicalBase}/${shareImage.uri}`;
      const shareImageCaption = topImageSet.caption;

      _meta("twitter:image", shareImageUri);
      _meta("twitter:image:alt", shareImageCaption);

      _ogMeta("og:image:secure_url", shareImageUri);
      _ogMeta("og:image:height", shareImage.height);
      _ogMeta("og:image:width", shareImage.width);
      _ogMeta("og:image:type", shareImage.mime_type);
      _ogMeta("og:image:alt", shareImageCaption);
    }

    // TODO Populate OG if video hero
  }

  if (article.keywords && article.keywords.length) {
    _meta("keywords", article.keywords.join(","));
  }

  return <MetaDataWrapper helmetProps={helmetProps}/>
};

ArticleHelmetProps.propTypes = {
  embedded: PropTypes.bool,
  article: PropTypes.object,
  canonical: PropTypes.object,
  topImageSet: PropTypes.array
}

export default withErrorBoundary(ArticleHelmetProps);



// WEBPACK FOOTER //
// ./modules/News/components/ArticleHelmetProps.js